import getSymbolFromCurrency from 'currency-symbol-map';

const currencyFormatter = (currency, price) => {
    let locale_price = parseFloat(price).toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 2});
    return `${getSymbolFromCurrency(currency)} ${locale_price}`;
}

export default currencyFormatter;